import React, { useEffect } from 'react';
import { map, isEmpty } from 'lodash';
import { arrayOf, object, string, elementType } from 'prop-types';
import ReactTooltip from 'react-tooltip';

const GenericTooltip = ({ tooltipId, tooltipData, content }) => {
   useEffect(() => {
      ReactTooltip.rebuild();
   });

   const generateTooltip = () => {
      return (
         tooltipData && (
            <>
               <div className='generic-tooltip-title'>
                  {tooltipData.tooltipTitle}
               </div>
               <ul className='generic-tooltip-data'>
                  {map(tooltipData.tooltipDetails, (eachData, eachKey) => {
                     if (eachData.value && eachData.column.Header) {
                        return (
                           <li className='generic-tooltip-data-list'>
                              <span>{eachData.column.Header}:&nbsp;&nbsp;</span>
                              <span>{eachData.value}</span>
                           </li>
                        );
                     }
                  })}
               </ul>
            </>
         )
      );
   };

   const getContent = () => (isEmpty(content) ? generateTooltip() : content);

   return (
      <ReactTooltip id={tooltipId} aria-haspopup='true'>
         {getContent()}
      </ReactTooltip>
   );
};

GenericTooltip.propTypes = {
   tooltipId: string.isRequired,
   tooltipData: arrayOf(object),
   content: elementType,
};

export default GenericTooltip;
